import { P4Medium as P4MediumStyle } from 'theme/typography';
import { Text, TextProps } from '@mantine/core';
import mergeTextSx from 'components/typography/merge-text-sx';

/**
 * Applies the P4Medium typography style.
 */
export default function P4Medium({ sx, ...props }: TextProps) {
  return <Text {...props} sx={mergeTextSx(P4MediumStyle, sx)} />;
}
